"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = indexToLetter;
function indexToLetter(index) {
  // Returns up to 702 unique letter combinations from A-ZZ
  if (index >= 26) {
    return String.fromCharCode(65 + Math.floor(index / 26) - 1) + String.fromCharCode(65 + index % 26);
  }
  return String.fromCharCode(65 + index);
}